import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f13f40b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tags" }
const _hoisted_2 = { class: "tags has-addons mb-0" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Are you sure you want to delete this transcription? ", -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfidenceTag = _resolveComponent("ConfidenceTag")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.transcription.confidence && Number.isFinite(_ctx.transcription.confidence))
      ? (_openBlock(), _createBlock(_component_ConfidenceTag, {
          key: 0,
          value: _ctx.transcription.confidence
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.transcription.worker_run)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["tag button px-1 icon-copy has-text-primary", { 'is-loading': _ctx.loading }]),
            disabled: !_ctx.canCopy || _ctx.loading || undefined,
            title: "Copy this transcription to a manual transcription",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyTranscription && _ctx.copyTranscription(...args)))
          }, null, 10, _hoisted_3))
        : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(["tag button px-1 icon-edit has-text-primary", { 'is-loading': _ctx.loading }]),
            disabled: !_ctx.canEdit || _ctx.loading || undefined,
            title: "Edit this transcription",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editTranscription && _ctx.editTranscription(...args)))
          }, null, 10, _hoisted_4)),
      _createElementVNode("span", {
        class: _normalizeClass(["tag button px-1 icon-trash has-text-danger", { 'is-loading': _ctx.loading }]),
        disabled: !_ctx.canDelete || _ctx.loading || undefined,
        title: "Delete this transcription",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmDeleteModal = _ctx.canDelete && !_ctx.loading))
      }, null, 10, _hoisted_5)
    ]),
    _createVNode(_component_Modal, {
      modelValue: _ctx.confirmDeleteModal,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.confirmDeleteModal) = $event)),
      title: "Delete transcription"
    }, {
      footer: _withCtx(({ close }) => [
        _createElementVNode("button", {
          class: "button",
          onClick: close
        }, "Cancel", 8, _hoisted_7),
        _createElementVNode("button", {
          class: _normalizeClass(["button is-danger", { 'is-loading': _ctx.loading }]),
          disabled: _ctx.loading || undefined,
          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteTranscription && _ctx.deleteTranscription(...args)), ["prevent"]))
        }, " Delete ", 10, _hoisted_8)
      ]),
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}